const ADMIN_PATH_PATTERNS = [
  /^\/admin(?:\/|$)/,
  /^\/workspaces\/admin(?:\/|$)/,
  /^\/workspaces\/broadcast(?:\/|$)/,
  /^\/workspaces\/[^/]+\/(?:edit|positioning)(?:\/|$)/,
  /^\/help\/admin(?:\/|$)/,
  /^\/dem-cog\/dems(?:\/|$)/,
];

function pathnameFromHref(href) {
  if (typeof href !== "string" || !href.trim()) return "";

  try {
    return new URL(href, "https://salesably.local").pathname;
  } catch {
    return href.split(/[?#]/, 1)[0];
  }
}

export function canSearchAdminNavigation(sessionUser) {
  return (
    sessionUser?.role === "admin" ||
    sessionUser?.superUser === true
  );
}

export function isAdminNavigationResult(result) {
  if (!result || typeof result !== "object") return false;
  if (result.group === "Admin pages" || result.kind === "admin") return true;
  if (result.section === "Admin") return true;

  const pathname = pathnameFromHref(result.href);
  return ADMIN_PATH_PATTERNS.some((pattern) => pattern.test(pathname));
}

export function filterNavigationResultsForUser(results, sessionUser) {
  const normalizedResults = Array.isArray(results) ? results : [];
  if (canSearchAdminNavigation(sessionUser)) return normalizedResults;
  return normalizedResults.filter((result) => !isAdminNavigationResult(result));
}
